import { useMemo } from "react";

import { useCsvExportColumnOptions } from "app/pages/sales-intelligence/modules/enrichment/hooks/useCsvExportColumnOptions";
import { columnsExportService } from "app/pages/sales-intelligence/modules/enrichment/services/columns-export/columnsExportService";
import type { ColumnsConfigType } from "app/pages/sales-intelligence/modules/enrichment/store/type";

type HookValue = {
    config: readonly ColumnsConfigType[];
    isConfigLoading: boolean;
};

export const useColumnConfigs = (): HookValue => {
    const { data: columnsData, isLoading: isConfigLoading } = useCsvExportColumnOptions();

    const config = useMemo((): readonly ColumnsConfigType[] => {
        if (!columnsData) {
            return [];
        }

        return columnsExportService.buildLeadsConfig(columnsData);
    }, [columnsData]);

    return { config, isConfigLoading };
};
